export const maintenanceServicesData = [
  {
    id: 1,
    serviceName: "5,000 Miles Maintenance Service",
    mileage: 5000,
    interval: "6 months",
    serviceType: "Basic Service",
    durationMin: 30,
    durationMax: 60,
    priceMin: 50,
    priceMax: 100,
    description: "Basic Service for 5,000 miles - Essential maintenance to keep your vehicle running smoothly.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights"
    ]
  },
  {
    id: 2,
    serviceName: "10,000 Miles Maintenance Service",
    mileage: 10000,
    interval: "12 months",
    serviceType: "Basic Service",
    durationMin: 30,
    durationMax: 60,
    priceMin: 50,
    priceMax: 100,
    description: "Basic Service for 10,000 miles - Regular maintenance to ensure reliability and performance.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights"
    ]
  },
  {
    id: 3,
    serviceName: "15,000 Miles Maintenance Service",
    mileage: 15000,
    interval: "18 months",
    serviceType: "Minor Service",
    durationMin: 60,
    durationMax: 90,
    priceMin: 150,
    priceMax: 250,
    description: "Minor Service for 15,000 miles - Extended maintenance with additional inspections and filter replacements.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights",
      "Replace engine air filter",
      "Replace cabin air filter if equipped",
      "Inspect suspension, steering components, and driveshaft boots",
      "Inspect exhaust system for leaks or corrosion"
    ]
  },
  {
    id: 4,
    serviceName: "20,000 Miles Maintenance Service",
    mileage: 20000,
    interval: "24 months",
    serviceType: "Basic Service",
    durationMin: 30,
    durationMax: 60,
    priceMin: 50,
    priceMax: 100,
    description: "Basic Service for 20,000 miles - Continued essential maintenance for optimal vehicle health.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights"
    ]
  },
  {
    id: 5,
    serviceName: "25,000 Miles Maintenance Service",
    mileage: 25000,
    interval: "30 months",
    serviceType: "Basic Service",
    durationMin: 30,
    durationMax: 60,
    priceMin: 50,
    priceMax: 100,
    description: "Basic Service for 25,000 miles - Standard maintenance to maintain vehicle performance.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights"
    ]
  },
  {
    id: 6,
    serviceName: "30,000 Miles Maintenance Service",
    mileage: 30000,
    interval: "36 months",
    serviceType: "Intermediate Service",
    durationMin: 90,
    durationMax: 150,
    priceMin: 300,
    priceMax: 500,
    description: "Intermediate Service for 30,000 miles - Comprehensive maintenance with fluid inspections and replacements.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights",
      "Replace engine air filter if not already done",
      "Replace cabin filter if not already done",
      "Replace fuel filter if serviceable",
      "Inspect or flush brake fluid; every 2 years is common",
      "Inspect cooling system & coolant; flush if needed",
      "Inspect transmission fluid; replace if dirty or due",
      "Inspect differential fluid for AWD/4WD vehicles"
    ]
  },
  {
    id: 7,
    serviceName: "35,000 Miles Maintenance Service",
    mileage: 35000,
    interval: "42 months",
    serviceType: "Basic Service",
    durationMin: 30,
    durationMax: 60,
    priceMin: 50,
    priceMax: 100,
    description: "Basic Service for 35,000 miles - Essential maintenance between major service intervals.",
    includes: [
      "Oil & filter change",
      "Tire rotation & inspection",
      "Check brakes including pads, rotors, and fluid",
      "Top up fluids including coolant, brake fluid, washer fluid, and power steering fluid if applicable",
      "Inspect belts & hoses",
      "Check battery & lights"
    ]
  },
  {
    id: 8,
    serviceName: "60,000 Miles Maintenance Service",
    mileage: 60000,
    interval: "4-5 years",
    serviceType: "Major Service",
    durationMin: 180,
    durationMax: 300,
    priceMin: 500,
    priceMax: 900,
    description: "Major Service for 60,000 miles - Comprehensive service including spark plugs and timing inspection.",
    includes: [
      "All items from 30,000 miles maintenance service",
      "Replace spark plugs & perform ignition inspection",
      "Replace serpentine/accessory belt if worn",
      "Inspect timing belt/chain; replace if required by manufacturer",
      "Transmission fluid replacement if not done earlier",
      "Differential/transfer case fluid replacement for AWD/4WD vehicles",
      "Flush power steering fluid if hydraulic system"
    ]
  },
  {
    id: 9,
    serviceName: "90,000-100,000 Miles Maintenance Service",
    mileage: 95000,
    interval: "6-8 years",
    serviceType: "Major/Extended Service",
    durationMin: 300,
    durationMax: 480,
    priceMin: 800,
    priceMax: 1500,
    description: "Major/Extended Service for 90,000-100,000 miles - Critical service milestone with timing belt and water pump replacement.",
    includes: [
      "All items from 60,000 miles maintenance service",
      "Replace timing belt; mandatory if not already done, many cars specify around 90,000 miles",
      "Replace water pump; often done with timing belt",
      "Inspect or replace motor mounts",
      "Thorough inspection of suspension; struts/shocks often due by now",
      "Replace spark plugs if iridium/platinum 100,000-mile plugs"
    ]
  },
  {
    id: 10,
    serviceName: "100,000+ Miles Maintenance Service",
    mileage: 100000,
    interval: "Repeat every 20,000-30,000 miles",
    serviceType: "Extended Life Service",
    durationMin: 120,
    durationMax: 240,
    priceMin: 400,
    priceMax: 800,
    description: "Extended Life Service for mileage beyond 100,000 miles - Ongoing maintenance with focus on aging components.",
    includes: [
      "Repeat 30,000 miles and 60,000 miles maintenance service items",
      "More frequent inspection of major components",
      "Inspect suspension including shocks, struts, and bushings",
      "Inspect exhaust system for rust or leaks",
      "Inspect cooling system including hoses and radiator",
      "Inspect alternator & starter condition",
      "Inspect wheel bearings & CV joints"
    ]
  }
];

export default maintenanceServicesData;
